import { Fragment } from "react"

import { define } from "@/components/builder/utils"

import { DroppablePlaceholder } from "../utils/Placeholder"

function Placeholder({ children }) {
  if (children) return children

  return <DroppablePlaceholder>
    Drop here
  </DroppablePlaceholder>
}

export default define('placeholder', Placeholder, Fragment)
  .build()
